import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaButton'

type IcaButtonProps = React.JSX.IntrinsicElements['tgdb-ica-button']

export const IcaButton = wrapWc<IcaButtonProps>('tgdb-ica-button', [])